import { Table } from '@twilio-paste/core/table';

import { TargetAuthHeaderFormValue } from '../types';

import { TargetAuthHeaderTableBody } from './TargetAuthHeaderTableBody';
import { TargetAuthHeaderTableHeader } from './TargetAuthHeaderTableHeader';

interface TargetAuthHeaderTableProps {
  authHeaders: TargetAuthHeaderFormValue[];
}

export function TargetAuthHeaderTable({ authHeaders }: TargetAuthHeaderTableProps) {
  return (
    <Table>
      <TargetAuthHeaderTableHeader />
      <TargetAuthHeaderTableBody authHeaders={authHeaders} />
    </Table>
  );
}
